import React from "react";
import { FaImage } from "react-icons/fa";
import styles from "./User.module.css";
import AvatarEditor from "react-avatar-editor";

const CoverImage = ({ setImageEditor, imageEditor }) => {
  const [image, setImage] = React.useState({ preview: "", raw: "" });
  const editorRef = React.useRef();
  const inputFileRef = React.useRef();

  const handleChange = (e) => {
    if (!e.target.files[0]) return;

    setImage({
      preview: URL.createObjectURL(e.target.files[0]),
      raw: e.target.files[0],
    });
  };

  React.useEffect(() => {
    setImageEditor(editorRef);
  }, [editorRef, setImageEditor]);

  return (
    <div className={styles.cover}>
      {image.preview ? (
        <React.Fragment>
          <AvatarEditor
            className={styles.imageEditor}
            image={image.preview}
            border={0}
            width={130}
            height={130}
            color={[81, 182, 225, 0.4]} // RGBA
            scale={1.2}
            rotate={0}
            ref={editorRef}
          />
          {/* <div className={styles.hint}>Drag Image to Resize</div> */}
        </React.Fragment>
      ) : (
        <div
          className={styles.placeholderAvatarImage}
          onClick={() => inputFileRef.current.click()}
        >
          <FaImage className={styles.icon} />
          <div>Choose Profile Image</div>
        </div>
      )}

      <input
        className={styles.imagePicker}
        type="file"
        id="coverImage"
        ref={inputFileRef}
        onChange={handleChange}
      />
    </div>
  );
};

export default CoverImage;
